/**
 * Floor managers monitor the floor (from Discord/Slack, the admin portal, the
 * roster) rather than claiming jobs or mutating tester data, so the ordinary
 * activity signals rarely fire for them. To stop them from sliding to
 * Away/Missing/Offline while actively covering, every inactivity threshold is
 * stretched by this multiplier for floor-manager accounts.
 *
 * Single source of truth shared by the server-side presence sweep
 * (auto-away / auto-offline) and the client-side `isMissing` overlay so a
 * floor manager's persisted demotions and their displayed "Missing" treatment
 * stay in lock-step at the same 2× factor.
 */
export const FLOOR_MANAGER_THRESHOLD_MULTIPLIER = 2;
/**
 * Stretches a base inactivity threshold (in minutes) for floor managers.
 * Returns the base unchanged for everyone else.
 */
export function floorManagerAdjustedMinutes(baseMinutes, isFloorManager) {
    return isFloorManager ? baseMinutes * FLOOR_MANAGER_THRESHOLD_MULTIPLIER : baseMinutes;
}
//# sourceMappingURL=floor-manager-thresholds.js.map